// GEL BÊTA le 07/10/2026. Voir docs/GEL_BETA.md.
// Architecture figée : paiement dual, Coco via settings, rôles user_roles/has_role, âge 18 soft, pas de Connect.
// Porte ouverte : corrections de retours testeurs uniquement sur ordre Hiti, lot unique, sans rouvrir ces règles.
// Interdit sans Hiti : tama-wip→main, édition client.ts / types.ts / .env / config.toml / previewAuthStorage.
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Loader2 } from "lucide-react";
import { joinBetaWaitlist } from "@/services/admin/betaSignup";

/** Formulaire affiché à la place de l'inscription quand le palier bêta est plein. */
export const BetaWaitlistForm = ({ inTab = false }: { inTab?: boolean }) => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<{ ok: boolean; text: string } | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    const refusal = await joinBetaWaitlist(fullName, email);
    setLoading(false);
    setMessage(refusal ? { ok: false, text: refusal } : { ok: true, text: "Tu es sur la liste d'attente." });
  };

  return (
    <div className={inTab ? "space-y-3 pt-2" : "mt-4 space-y-3 border-t border-border pt-4"}>
      <p className="text-sm text-muted-foreground">
        Les inscriptions de la bêta sont complètes. Laisse ton nom et ton e-mail : on t'écrit quand une place s'ouvre.
      </p>
      {inTab && (
        <p className="text-sm text-muted-foreground">Tu as déjà un compte TAMA ? Ouvre l'onglet Connexion.</p>
      )}
      {message?.ok ? (
        <Alert><AlertDescription>{message.text}</AlertDescription></Alert>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-3">
          <div className="space-y-1.5">
            <Label htmlFor="waitlistFullName" className="text-sm">Nom complet <span className="text-destructive">*</span></Label>
            <Input id="waitlistFullName" value={fullName} onChange={(e) => setFullName(e.target.value)} required disabled={loading} />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="waitlistEmail" className="text-sm">E-mail <span className="text-destructive">*</span></Label>
            <Input id="waitlistEmail" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required disabled={loading} />
          </div>
          {message && <p className="text-sm text-destructive">{message.text}</p>}
          <Button type="submit" variant="outline" className="w-full" disabled={loading}>
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Rejoindre la liste d'attente
          </Button>
        </form>
      )}
    </div>
  );
};

export default BetaWaitlistForm;
